import { render, staticRenderFns } from "./SafetyStaffManagerment.vue?vue&type=template&id=5fa03832&scoped=true&"
import script from "./SafetyStaffManagerment.vue?vue&type=script&lang=js&"
export * from "./SafetyStaffManagerment.vue?vue&type=script&lang=js&"
import style0 from "./SafetyStaffManagerment.vue?vue&type=style&index=0&id=5fa03832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa03832",
  null
  
)

export default component.exports